






















































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import flatpickr from 'flatpickr'
import { Norwegian } from 'flatpickr/dist/l10n/no'
import moment from 'moment'

import SectionBase from '@/mixins/SectionBase'
import OrderSectionBase from './OrderSectionBase'

@Component({
  mixins: [SectionBase, OrderSectionBase],
})
export default class SectionDelivery extends Vue {
  minDate = new Date()
  maxDate = moment(this.minDate).add(1, 'years').toDate()

  get dateBetween (): string {
    const begin = moment(this.minDate).subtract(1, 'day')
    const end = moment(this.maxDate).add(1, 'day')
    const format = 'DD/MM/YYYY'
    return `${begin.format(format),end.format(format)}`
  }

  mounted () {
    const dateInputConfig = {
      allowInput: true,
      minDate: this.minDate,
      maxDate: this.maxDate,
      defaultDate: this.minDate,
      dateFormat: 'd/m/Y',
      weekNumbers: true,
      locale: Norwegian,
    }

    flatpickr(this.$refs.hullDate as HTMLElement, dateInputConfig)
    flatpickr(this.$refs.countertopDate as HTMLElement, dateInputConfig)
    flatpickr(this.$refs.measurementsDate as HTMLElement, dateInputConfig)
  }
}
